import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { saveServizi, completeOnboarding } from '../services/firebase';
import { Button, Spinner } from '../components/ui';

// Servizi predefiniti come punto di partenza — il gestore può modificarli
const PRESET_SERVIZI = [
  { label: 'Ombrellone', haFila: true,  colore: '#1f93e0', icona: '☂️' },
  { label: 'Lettino',    haFila: false, colore: '#2A6E7F', icona: '🛏' },
  { label: 'Cabina',     haFila: false, colore: '#3a8fa3', icona: '🏠' },
  { label: 'Gazebo',     haFila: true,  colore: '#0f6e56', icona: '⛺' },
  { label: 'Sdraio',     haFila: false, colore: '#854F0B', icona: '🪑' },
];

const COLORI = [
  '#1f93e0','#2A6E7F','#3a8fa3','#0f6e56','#854F0B',
  '#7F77DD','#D85A30','#D4537E','#639922','#BA7517',
];

export default function Onboarding() {
  const { admin, refreshBeach } = useAuth();
  const navigate = useNavigate();
  const [saving, setSaving]   = useState(false);

  // Servizi selezionati — inizia con ombrellone e lettino come default
  const [servizi, setServizi] = useState([
    { id: 's1', label: 'Ombrellone', haFila: true,  colore: '#1f93e0', icona: '☂️' },
    { id: 's2', label: 'Lettino',    haFila: false, colore: '#2A6E7F', icona: '🛏' },
  ]);

  const [nuovoForm, setNuovoForm] = useState({ label: '', haFila: false, colore: COLORI[0], icona: '🏖️' });
  const [showForm, setShowForm]   = useState(false);

  const addPreset = (preset) => {
    if (servizi.find(s => s.label === preset.label)) return;
    const id = `s${Date.now()}`;
    setServizi(prev => [...prev, { id, ...preset }]);
  };

  const addCustom = () => {
    if (!nuovoForm.label.trim()) return;
    const id = `s${Date.now()}`;
    setServizi(prev => [...prev, { id, ...nuovoForm }]);
    setNuovoForm({ label: '', haFila: false, colore: COLORI[0], icona: '🏖️' });
    setShowForm(false);
  };

  const removeServizio = (id) => setServizi(prev => prev.filter(s => s.id !== id));

  const toggleFila = (id) => setServizi(prev =>
    prev.map(s => s.id === id ? { ...s, haFila: !s.haFila } : s)
  );

  const handleSave = async () => {
    if (!servizi.length) return;
    setSaving(true);
    try {
      await saveServizi(admin.beachCode, servizi);
      await completeOnboarding(admin.uid);
      await refreshBeach();
      navigate('/beach-builder');
    } finally {
      setSaving(false);
    }
  };

  const inputStyle = {
    background: 'var(--surface)', border: '1px solid var(--border-mid)',
    borderRadius: 'var(--radius-md)', color: '#fff',
    padding: '8px 12px', fontSize: '13px', fontFamily: 'var(--font-sans)',
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--navy)',
      backgroundImage: 'radial-gradient(ellipse at 60% 10%, rgba(31,147,224,0.07) 0%, transparent 60%)',
      display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
      padding: '48px 20px',
    }}>
      <div style={{ width: '100%', maxWidth: '580px' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <div style={{ fontSize: '28px', marginBottom: '8px' }}>👋</div>
          <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: '24px', fontWeight: 500 }}>
            Configura il tuo lido
          </h1>
          <p style={{ fontSize: '13px', color: 'var(--text-muted)', marginTop: '6px' }}>
            Scegli i servizi che offri — potrai modificarli in qualsiasi momento
          </p>
        </div>

        {/* Card */}
        <div style={{
          background: 'var(--navy-mid)', border: '1px solid var(--border)',
          borderRadius: 'var(--radius-lg)', padding: '28px',
        }}>
          {/* Servizi attivi */}
          <div style={{ marginBottom: '24px' }}>
            <div style={{ fontSize: '12px', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '12px' }}>
              Servizi configurati
            </div>
            {servizi.length === 0 && (
              <div style={{ fontSize: '13px', color: 'var(--text-muted)', padding: '16px 0', textAlign: 'center' }}>
                Nessun servizio ancora — aggiungine almeno uno
              </div>
            )}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {servizi.map((s) => (
                <div key={s.id} style={{
                  display: 'flex', alignItems: 'center', gap: '10px',
                  background: 'var(--surface)', border: '1px solid var(--border)',
                  borderRadius: 'var(--radius-md)', padding: '10px 14px',
                }}>
                  <div style={{
                    width: '32px', height: '32px', borderRadius: '8px',
                    background: s.colore + '25', border: `1px solid ${s.colore}50`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '16px', flexShrink: 0,
                  }}>
                    {s.icona}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13.5px', fontWeight: 500 }}>{s.label}</div>
                    <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '1px' }}>
                      {s.haFila ? 'Prezzo per fila' : 'Prezzo fisso'}
                    </div>
                  </div>
                  {/* Toggle haFila */}
                  <button
                    onClick={() => toggleFila(s.id)}
                    title={s.haFila ? 'Prezzo varia per fila' : 'Prezzo fisso'}
                    style={{
                      padding: '4px 10px', borderRadius: '20px', fontSize: '11px',
                      border: `1px solid ${s.haFila ? 'var(--ocean)' : 'var(--border-mid)'}`,
                      background: s.haFila ? 'var(--ocean-dim)' : 'transparent',
                      color: s.haFila ? 'var(--ocean)' : 'var(--text-muted)',
                      cursor: 'pointer', fontFamily: 'var(--font-sans)',
                    }}
                  >
                    {s.haFila ? '↕ per fila' : '= fisso'}
                  </button>
                  <button
                    onClick={() => removeServizio(s.id)}
                    style={{
                      width: '26px', height: '26px', borderRadius: '50%',
                      border: '1px solid var(--border)', background: 'transparent',
                      color: 'var(--text-muted)', cursor: 'pointer', fontSize: '13px',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Preset rapidi */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '12px', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '10px' }}>
              Aggiungi da preset
            </div>
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
              {PRESET_SERVIZI.map((p) => {
                const già = servizi.find(s => s.label === p.label);
                return (
                  <button
                    key={p.label}
                    onClick={() => addPreset(p)}
                    disabled={!!già}
                    style={{
                      padding: '6px 14px', borderRadius: '20px', fontSize: '12.5px',
                      border: `1px solid ${già ? 'var(--border)' : 'var(--border-mid)'}`,
                      background: già ? 'var(--surface)' : 'transparent',
                      color: già ? 'var(--text-muted)' : 'var(--text-soft)',
                      cursor: già ? 'default' : 'pointer',
                      fontFamily: 'var(--font-sans)', opacity: già ? 0.5 : 1,
                    }}
                  >
                    {p.icona} {p.label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Form servizio personalizzato */}
          {showForm ? (
            <div style={{
              background: 'var(--surface)', border: '1px solid var(--border)',
              borderRadius: 'var(--radius-md)', padding: '16px', marginBottom: '20px',
            }}>
              <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginBottom: '12px' }}>Nuovo servizio personalizzato</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 80px', gap: '10px', marginBottom: '10px' }}>
                <input
                  placeholder="Nome servizio (es. Villetta, Gazebo...)"
                  value={nuovoForm.label}
                  onChange={e => setNuovoForm(p => ({ ...p, label: e.target.value }))}
                  style={{ ...inputStyle, width: '100%' }}
                />
                <input
                  placeholder="Emoji"
                  value={nuovoForm.icona}
                  onChange={e => setNuovoForm(p => ({ ...p, icona: e.target.value }))}
                  style={{ ...inputStyle, width: '100%', textAlign: 'center', fontSize: '18px' }}
                />
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '12px', flexWrap: 'wrap' }}>
                <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>Colore:</span>
                {COLORI.map(c => (
                  <div
                    key={c}
                    onClick={() => setNuovoForm(p => ({ ...p, colore: c }))}
                    style={{
                      width: '20px', height: '20px', borderRadius: '50%', background: c,
                      cursor: 'pointer', border: nuovoForm.colore === c ? '2px solid #fff' : '2px solid transparent',
                    }}
                  />
                ))}
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '12px' }}>
                <label style={{ fontSize: '12px', color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={nuovoForm.haFila}
                    onChange={e => setNuovoForm(p => ({ ...p, haFila: e.target.checked }))}
                  />
                  Prezzo varia in base alla fila (prima fila più cara)
                </label>
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <Button variant="primary" size="sm" onClick={addCustom}>Aggiungi</Button>
                <Button variant="ghost" size="sm" onClick={() => setShowForm(false)}>Annulla</Button>
              </div>
            </div>
          ) : (
            <button
              onClick={() => setShowForm(true)}
              style={{
                width: '100%', padding: '10px', borderRadius: 'var(--radius-md)',
                border: '1px dashed var(--border-mid)', background: 'transparent',
                color: 'var(--text-muted)', fontSize: '13px', cursor: 'pointer',
                fontFamily: 'var(--font-sans)', marginBottom: '20px',
                transition: 'all 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.color = 'var(--text-soft)'; e.currentTarget.style.borderColor = 'var(--border-mid)'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'var(--text-muted)'; e.currentTarget.style.borderColor = 'var(--border)'; }}
            >
              + Aggiungi servizio personalizzato
            </button>
          )}

          <Button
            variant="sand"
            fullWidth
            size="lg"
            onClick={handleSave}
            disabled={saving || servizi.length === 0}
          >
            {saving ? <Spinner size={16} /> : 'Continua → Costruisci la spiaggia'}
          </Button>
        </div>

        <p style={{ textAlign: 'center', fontSize: '12px', color: 'var(--text-muted)', marginTop: '16px' }}>
          Potrai modificare i servizi in qualsiasi momento dalle impostazioni
        </p>
      </div>
    </div>
  );
}
